import React from 'react';
import { Col, Table, Popover, Typography } from 'antd';

const { Title } = Typography;

const Statistics = ({ certifications, rsSkillsGroup, rsProfiles }) => {
  const selectedSkillIds = React.useMemo(() => {
    const allIds = certifications.flatMap((c) => c.skills_group);
    return Array.from(new Set(allIds)).sort((a, b) => a - b);
  }, [certifications]);

  const enisaProfileCoverage = React.useMemo(() => {
    return rsProfiles.map((profile) => {
      const included = [],
        missing = [];
      profile.skills_group.forEach((id) => (selectedSkillIds.includes(id) ? included : missing).push(id));
      return {
        key: profile.name,
        name: profile.name,
        coverage: Math.round((included.length / profile.skills_group.length) * 100),
        included,
        missing,
      };
    });
  }, [rsProfiles, selectedSkillIds]);

  const median = (arr) => {
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
  };

  const percentageLevel = (percent) => (percent > 67 ? 'High' : percent > 33 ? 'Medium' : percent >= 0 ? 'Low' : 'Error');

  const ecsfData = enisaProfileCoverage.map((p, i) => ({ key: i, profile: p.name, coverage: percentageLevel(p.coverage), p }));
  const ecsfColumns = [
    { title: 'Profile Name', dataIndex: 'profile', key: 'profile' },
    {
      title: 'Coverage',
      dataIndex: 'coverage',
      key: 'coverage',
      align: 'center',
      onCell: (record) => ({
        className: record.p.coverage === 100 ? 'green' : 'normal',
      }),
      render: (text, record) => (
        <Popover
          placement="leftBottom"
          arrowPointAtCenter
          getPopupContainer={(trigger) => trigger.parentElement}
          trigger="hover"
          content={
            <div className="skills-popover">
              <Title level={4}>{record.p.name}</Title>
              <Title level={5}>Included Skills</Title>
              <ul>{record.p.included.length > 0 ? record.p.included.map((sg, i) => <li key={i}>{rsSkillsGroup.find((e) => e.id === sg).name}</li>) : <span className="empty">None</span>}</ul>
              <Title level={5}>Missing Skills</Title>
              <ul>{record.p.missing.length > 0 ? record.p.missing.map((sg, i) => <li key={i}>{rsSkillsGroup.find((e) => e.id === sg).name}</li>) : <span className="empty">None</span>}</ul>
            </div>
          }
        >
          <div className="coverage-text">
            {text}
          </div>
        </Popover>
      ),
    },
  ];

  // Median row data
  const medianCoverage = median(enisaProfileCoverage.map((p) => p.coverage));

  return (
    <Col xs={24} lg={24} xl={8} className="base-statistics">
      <h3 className="section-title">Statistics</h3>
      <div className="base-statistics-content">
        {certifications.length > 0 ? (
          <div className="statistics-results">
            <h6>ENISA Profiles coverage:</h6>
            <Table
              dataSource={ecsfData}
              columns={ecsfColumns}
              pagination={false}
              footer={() => (
                <div className="statistics-footer">
                  <div className="result-text">Result (median): </div>
                  <div className={medianCoverage === 100 ? 'green' : 'normal'}>{percentageLevel(medianCoverage)}</div>
                </div>
              )}
            />
          </div>
        ) : (
          <div className="empty-data">
            <span className="header">There are no certifications yet.</span>
            <br />
            Drag some course to your certification list.
          </div>
        )}
      </div>
    </Col>
  );
};

export default Statistics;
